import ShipBobAuthentication from '@shipbob/auth';
import { ENV } from '@/env';

const localAuthenticationInformation = {
  authority: ENV.AUTHENTICATION_AUTHORITY,
  client_id: ENV.CLIENT_ID,
  scope: ENV.CLIENT_SCOPE,
  post_logout_redirect_uri: `${globalThis.location.protocol}//${globalThis.location.host}/`,
  redirect_uri: `${globalThis.location.protocol}//${globalThis.location.host}/signin-callback`,
  response_type: 'code',
  // if token delegation is enabled, we don't want to do silent renew
  automaticSilentRenew: !ENV.ENABLE_TOKEN_DELEGATION,
};


export const getDelegationToken = () => {
  if (window.location.hash?.indexOf('#token=') != -1) {
    return window.location.hash.replace('#token=', '');
  }

  return '';
};

let localAuthService = null;

export function getAuthService(parentAuthService) {
  if (parentAuthService) {
    localAuthService = parentAuthService;
  }

  if (localAuthService) {
    return localAuthService;
  }

  localAuthService = new ShipBobAuthentication(localAuthenticationInformation);

  return localAuthService;
}